import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ShieldCheck } from 'lucide-react';
import { LogoLink } from '../components/Logo';

export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle: string;
  children: ReactNode;
  footer: ReactNode;
}) {
  return (
    <div className="relative flex min-h-screen flex-col overflow-hidden">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-[-280px] size-[680px] -translate-x-1/2 rounded-full bg-violet-600/[0.12] blur-[150px]" />
        <div className="absolute bottom-[-300px] right-[-100px] size-[520px] rounded-full bg-cyan-500/[0.06] blur-[140px]" />
      </div>

      <header className="relative z-10 mx-auto flex h-20 w-full max-w-7xl items-center justify-between px-4 sm:px-6">
        <LogoLink />
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-[13px] text-zinc-500 transition-colors hover:text-zinc-200"
        >
          <ArrowLeft className="size-3.5" />
          На главную
        </Link>
      </header>

      <main className="relative z-10 flex flex-1 items-center justify-center px-4 pb-16 pt-6">
        <div className="fade-in w-full max-w-[420px]">
          <div className="mb-7 text-center">
            <h1 className="text-[28px] font-semibold tracking-[-0.035em] text-white">{title}</h1>
            <p className="mt-2 text-[13px] leading-relaxed text-zinc-500">{subtitle}</p>
          </div>

          <div className="rounded-2xl border border-white/[0.08] bg-[#0d0f15]/80 p-6 shadow-[0_30px_90px_-30px_rgba(0,0,0,0.8)] backdrop-blur-xl sm:p-7">
            {children}
          </div>

          <div className="mt-5 text-center text-[13px] text-zinc-500">{footer}</div>

          <p className="mt-8 flex items-center justify-center gap-1.5 text-[11px] text-zinc-700">
            <ShieldCheck className="size-3.5" />
            Пароли хранятся только в виде Argon2id-хеша
          </p>
        </div>
      </main>
    </div>
  );
}
